import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import React, { useEffect, useState } from "react"
import { styled } from '@mui/material/styles';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Visibility } from '@mui/icons-material';


const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} style={{backgroundColor:props.primary?"#656769":props.light?props.active?"#656769":"#b1b2b3":"#65676980", marginRight:props.child?"":"5px",visibility: props.visibility ? props.visibility : 'visible'}}/>))(({ theme }) => ({
    color:"white",
    marginBottom:"10px",
    fontSize:20,
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
}));


export const ListAcordion = (props) => {
    return(
      <Accordion expanded={props.expanded} child={props.child} primary={props.primary} light={props.light} onChange={props.toggle()} active={props.active} visibility={props.visibility ? props.visibility : 'visible'}>
       <AccordionSummary
                style={{padding:"0 29px 0 29px", height:"60px"}}
                expandIcon={<ArrowDropDownIcon style={{color:"white"}}/>}
                aria-controls="panel1a-content"
                id="panel1a-header"
                className={`${props.active?"selected":""}`}
                >
                {props.label}
            </AccordionSummary>
            <AccordionDetails style={{backgroundColor:"white", paddingLeft:0, paddingRight:0, paddingBottom:.1}}>
            {props.children}
            </AccordionDetails>
        </Accordion>
    )
}